module.exports = __webpack_public_path__ + "img/f7e9eb2.jpg";